/**
 * @generated SignedSource<<1b6419ba6e13336fe5dd3885529c53e6>>
 * @relayHash fefdea0442a24e0184c061956d04762d
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fefdea0442a24e0184c061956d04762d

import { ConcreteRequest } from 'relay-runtime';
export type useDoc2URecipientsQuery$variables = Record<PropertyKey, never>;
export type useDoc2URecipientsQuery$data = {
  readonly ch_doc2URecipients: ReadonlyArray<{
    readonly email: string;
    readonly userName: string;
  }>;
};
export type useDoc2URecipientsQuery = {
  response: useDoc2URecipientsQuery$data;
  variables: useDoc2URecipientsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useDoc2URecipientsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PartnerUser",
        "kind": "LinkedField",
        "name": "ch_doc2URecipients",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useDoc2URecipientsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PartnerUser",
        "kind": "LinkedField",
        "name": "ch_doc2URecipients",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "fefdea0442a24e0184c061956d04762d",
    "metadata": {},
    "name": "useDoc2URecipientsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "abf6d71efe1610f60df8851c1cc17646";

export default node;
